'use strict';

exports.SpanLittleBigQueryBase = require('./span-little-big-query-base');

exports.SpanTermQuery = require('./span-term-query');
exports.SpanMultiTermQuery = require('./span-multi-term-query');
exports.SpanFirstQuery = require('./span-first-query');
exports.SpanNearQuery = require('./span-near-query');
exports.SpanOrQuery = require('./span-or-query');
exports.SpanNotQuery = require('./span-not-query');
exports.SpanContainingQuery = require('./span-containing-query');
exports.SpanWithinQuery = require('./span-within-query');
exports.SpanFieldMaskingQuery = require('./span-field-masking-query');
